import { useState } from "react";
import MenuFrame from "../frames/menu_frame";
import { AddBoxTwoTone, EditTwoTone, SaveRounded } from "@mui/icons-material";
import { getClientList } from "../booking/booking_halper";
import { Alert, Autocomplete, Backdrop, Box, Button, CircularProgress, Grid, IconButton, LinearProgress, Paper, TextField, Typography } from "@mui/material";
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import { acceptQuotation, getCompanyQuotationList, getQuotation, makeQuotation } from "./quotation_halper";
import DropDownLoading from "../frames/dropdown_loading";

function QuotationMaker() {
    const [isLoading, setIsLoading] = useState(false);
    const [clientList, setClientList] = useState(null);
    const [alertMessage, setAlertMessage] = useState(null);
    const [inputErrors, setInputErrors] = useState({});
    const [columnVisible, setColumnVisible] = useState({});
    const [schemeID, setSchemeID] = useState(null);

    const [courierColumns, setCourierColumns] = useState([]);
    const [courierRows, setCourierRows] = useState([]);
    const [cargoColumns, setCargoColumns] = useState([]);
    const [cargoRows, setCargoRows] = useState([]);
    const [airColumns, setAirColumns] = useState([]);
    const [airRows, setAirRows] = useState([]);

    const initData = async (auth) => {
        if (!auth) return;
        setClientList(await getClientList("quotation"));
        resetForm();
    }

    const resetValue = (rows, columns, prefix) => {
        const values = {};
        rows.forEach((row, i) => {
            columns.forEach((col, j) => {
                const field = document.querySelector(`input[name="${prefix}${row.id}${col.id}"]`);
                if (field) {
                    field.value = "";
                }
            });
        });

        return values;
    };

    const resetForm = () => {
        setCourierColumns([{ id: 1, title: "First 250gm" }, { id: 2, title: "First 500gm" }, { id: 3, title: "Additional 500gm" }]);
        setCourierRows([{ id: 1, title: "Within City" }, { id: 2, title: "Within State" }, { id: 3, title: "Within East Zone" }, { id: 4, title: "Rest of India" }]);
        setCargoColumns([{ id: 3, title: "per kg" }]);
        setCargoRows([{ id: 1, title: "Within City" }, { id: 2, title: "Within State" }, { id: 3, title: "Within East Zone" }, { id: 4, title: "Rest of India" }]);
        setAirColumns([{ id: 1, title: "per kg" }]);
        setAirRows([{ id: 1, title: "Within City" }, { id: 2, title: "Within State" }, { id: 3, title: "Within East Zone" }, { id: 4, title: "Rest of India" }]);

        resetValue(courierRows, courierColumns, "courier");
        resetValue(cargoRows, cargoColumns, "cargo");
        resetValue(airRows, airColumns, "air");

        setInputErrors({});
        setAlertMessage(null);
        setSchemeID(null);

    }

    const handleClientChange = (event) => {
        resetForm();
        setIsLoading(true);
        getCompanyQuotationList(event.target.value).then((res) => {
            if (res.length > 0) {
                setSchemeID(res[res.length - 1].scheme_id);
                return getQuotation(res[res.length - 1].scheme_id);
            }
            return null;
        }).then((res) => {
            if (res === null) return;

            const courier = res.find(item => item.scheme === "COURIER");
            const cargo = res.find(item => item.scheme === "CARGO");
            const air = res.find(item => item.scheme === "AIR");

            setCourierRows(courier.row_data || []);
            setCourierColumns(courier.column_data || []);
            setCargoRows(cargo.row_data || []);
            setCargoColumns(cargo.column_data || []);
            setAirRows(air.row_data || []);
            setAirColumns(air.column_data || []);

            res.forEach((obj) => {
                const schm = obj.scheme.toLowerCase();
                const itm_rows = obj.row_data || [];
                const itm_cols = obj.column_data || [];
                const itm_data = obj.scheme_data || [];
                itm_rows.forEach((row, rowIndex) => {
                    const schemeRow = itm_data[rowIndex];
                    const schemeKeys = Object.keys(schemeRow);
                    itm_cols.forEach((col, colIndex) => {
                        const schemeId = schemeKeys[colIndex];
                        const value = schemeRow[schemeId];
                        // console.log({ rowId: row.id, colId: col.id, schemeId, value });
                        const field = document.querySelector(`input[name="${schm}${row.id}${col.id}"]`);
                        if (field) { field.value = value; }
                    });
                });
            });
            setAlertMessage({ severity: "success", message: "Quotation loaded successfully.", });
            return;
        }).then(() => {
            setIsLoading(false);
        }).catch((err) => {
            // console.error(err);
            setIsLoading(false);
        })

    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const payload = {
            scheme_id: schemeID,
            client_id: formData.get("client"),
            courier_rows: courierRows,
            courier_columns: courierColumns,
            cargo_rows: cargoRows,
            cargo_columns: cargoColumns,
            air_rows: airRows,
            air_columns: airColumns,
            courier: courierRows.map((row) => {
                const values = {};
                courierColumns.forEach((column) => { values[`${row.id}${column.id}`] = formData.get(`courier${row.id}${column.id}`); });
                return values;
            }),
            cargo: courierRows.map((row) => {
                const values = {};
                cargoColumns.forEach((column) => { values[`${row.id}${column.id}`] = formData.get(`cargo${row.id}${column.id}`); });
                return values;
            }),
            air: courierRows.map((row) => {
                const values = {};
                airColumns.forEach((column) => { values[`${row.id}${column.id}`] = formData.get(`air${row.id}${column.id}`); });
                return values;
            }),
        };

        try {
            setIsLoading(true);
            const result = await makeQuotation(payload);
            setSchemeID(result.id);
            setAlertMessage({ severity: "success", message: result.message || "Quotation saved successfully.", });
        } catch (error) {
            setAlertMessage({ severity: "error", message: error.message || "Something went wrong.", });
        } finally {
            setIsLoading(false);
        }
    };

    const validateInputs = (event) => {
        setIsLoading(true);
        return true;
    }

    const handleShowColumn = (id) => {
        let tmp = { ...columnVisible };
        tmp[id] = !tmp[id];
        setColumnVisible(tmp);
    }

    const handleSaveColumn = (id) => {
        handleShowColumn(id);
    }

    const approveQuote = () => {
        if (schemeID === null) {
            setAlertMessage({ severity: "error", message: "Invalid quatation. Please re-check the quatation.", });
            return;
        }
        acceptQuotation({ quotation: schemeID }).then((res) => {
            console.log(res);
        }).catch((err) => {
            console.error(err);
        })
    }

    const resetSchemeID = () => {
        setSchemeID(null);
    }

    const tableHead = (columns) => {
        return (
            <Grid container size={12} spacing={2} component={Paper} sx={{ mt: 1, mb: 1, p: 1, display: { xs: "none", sm: "flex" } }} >
                <Grid size={{ xs: 12, sm: 4 }}>Region</Grid>
                {columns.map((column) => (
                    <Grid key={column.id} size={{ xs: 12, sm: 2 }}>
                        {column.title}
                    </Grid>
                ))}
            </Grid>
        );
    }

    return (
        <MenuFrame permission="ACCOUNTS_ORG" screen="ACCOUNTS" onInit={initData}>
            {clientList === null || clientList.length === 0 ? <LinearProgress color="primary" /> : ""}
            <Backdrop sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })} open={isLoading} >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container size={{ xs: 12, sm: 10 }} component="form" onSubmit={handleSubmit} noValidate spacing={2} sx={{ p: 2 }}>
                {alertMessage === null ? "" :
                    <Grid size={12}>
                        <Alert severity={alertMessage.severity}>{alertMessage.message}</Alert>
                    </Grid>
                }
                <Grid size={{ xs: 12, sm: 8 }}>
                    <Autocomplete
                        disablePortal
                        size="small"
                        noOptionsText={<DropDownLoading title="Loading Clients ..." />}
                        onBlur={handleClientChange}
                        options={clientList === null ? [] : clientList}
                        getOptionLabel={(option) => option.client_id}
                        renderOption={(props, option) => {
                            const { key, ...optionProps } = props;
                            return (
                                <Box key={key} component="li" {...optionProps} >
                                    {option.name} ({option.client_id})
                                </Box>
                            );
                        }}
                        renderInput={(params) => <TextField {...params} variant="outlined" name="client" fullWidth error={inputErrors.client} type="text" helperText={inputErrors.client} autoFocus placeholder="Client" label="Client" />}
                    />
                </Grid>
                <Grid size={{ xs: 12, sm: 2 }}>
                    <Button variant="contained" fullWidth disabled={!schemeID} onClick={resetSchemeID} color="info" sx={{ textTransform: "none" }}><AddBoxTwoTone /> New Quote</Button>
                </Grid>
                <Grid size={{ xs: 12, sm: 2 }}>
                    <Button variant="contained" fullWidth disabled={!schemeID} onClick={approveQuote} color="success" sx={{ textTransform: "none" }}><CheckCircleTwoToneIcon /> Approve</Button>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Typography variant="h6" fullWidth>Courier Services <Typography variant="body2" fullWidth>{schemeID}</Typography></Typography>
                </Grid>

                {tableHead(courierColumns)}
                {courierRows.map((row) => (
                    <Grid key={row.id} container size={12} spacing={2}>
                        <Grid size={{ xs: 11, sm: 3 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                {row.title}
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <TextField variant="standard" size="small" fullWidth name={`courier_rows${row.id}`} label={row.title} defaultValue={row.title} placeholder="Region name" type="text" error={!!inputErrors[`courier_rows${row.id}`]} helperText={inputErrors[`courier_rows${row.id}`]} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleShowColumn(row.id)}>
                                    <EditTwoTone color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleSaveColumn(row.id)}>
                                    <SaveRounded color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                        </Grid>

                        {courierColumns.map((column, index) => {
                            const fieldName = `courier${row.id}${column.id}`;
                            return (
                                <Grid key={fieldName} size={{ xs: 12, sm: 2 }}>
                                    <TextField variant="outlined" size="small" fullWidth name={fieldName} label={column.title} placeholder="₹" type="number" error={!!inputErrors[fieldName]} helperText={inputErrors[fieldName]} slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000, }, inputLabel: { shrink: true, } }} />
                                </Grid>
                            );
                        })}
                    </Grid>
                ))}

                <Typography variant="h6" fullWidth>Cargo (Surface or Railways or Freight)</Typography>

                {tableHead(cargoColumns)}
                {cargoRows.map((row) => (
                    <Grid key={row.id} container size={12} spacing={2}>
                        <Grid size={{ xs: 11, sm: 3 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                {row.title}
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <TextField variant="standard" size="small" fullWidth name={`cargo_rows${row.id}`} label={row.title} defaultValue={row.title} placeholder="Region name" type="text" error={!!inputErrors[`cargo_rows${row.id}`]} helperText={inputErrors[`cargo_rows${row.id}`]} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleShowColumn(row.id)}>
                                    <EditTwoTone color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleSaveColumn(row.id)}>
                                    <SaveRounded color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                        </Grid>

                        {cargoColumns.map((column, index) => {
                            const fieldName = `cargo${row.id}${column.id}`;
                            return (
                                <Grid key={fieldName} size={{ xs: 12, sm: 2 }}>
                                    <TextField variant="outlined" size="small" fullWidth name={fieldName} label={column.title} placeholder="₹" type="number" error={!!inputErrors[fieldName]} helperText={inputErrors[fieldName]} slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000, }, inputLabel: { shrink: true, } }} />
                                </Grid>
                            );
                        })}
                    </Grid>
                ))}

                <Typography variant="h6" fullWidth>Air Cargo</Typography>

                {tableHead(airColumns)}
                {airRows.map((row) => (
                    <Grid key={row.id} container size={12} spacing={2} >
                        <Grid size={{ xs: 11, sm: 3 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                {row.title}
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <TextField variant="standard" size="small" fullWidth name={`air_rows${row.id}`} label={row.title} defaultValue={row.title} placeholder="Region name" type="text" error={!!inputErrors[`air_rows${row.id}`]} helperText={inputErrors[`air_rows${row.id}`]} />
                            </Box>
                        </Grid>
                        <Grid size={{ xs: 1, sm: 1 }} sx={{ alignContent: "center" }}>
                            <Box sx={{ display: columnVisible[row.id] ? "none" : "" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleShowColumn(row.id)}>
                                    <EditTwoTone color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                            <Box sx={{ display: columnVisible[row.id] ? "" : "none" }}>
                                <IconButton aria-label="Show column option" size="small" onClick={() => handleSaveColumn(row.id)}>
                                    <SaveRounded color="secondary" fontSize="inherit" />
                                </IconButton>
                            </Box>
                        </Grid>

                        {airColumns.map((column, index) => {
                            const fieldName = `air${row.id}${column.id}`;
                            return (
                                <Grid key={fieldName} size={{ xs: 12, sm: 2 }}>
                                    <TextField variant="outlined" size="small" fullWidth name={fieldName} label={column.title} placeholder="₹" type="number" error={!!inputErrors[fieldName]} helperText={inputErrors[fieldName]} slotProps={{ htmlInput: { step: 0.01, min: 0, max: 100000, }, inputLabel: { shrink: true, } }} />
                                </Grid>
                            );
                        })}
                    </Grid>
                ))}

                <Grid size={{ xs: 12, sm: 12 }}>
                    <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="success">Save</Button>
                </Grid>
            </Grid>
        </MenuFrame>
    );
}

export default QuotationMaker;
